module.exports = __webpack_public_path__ + "images/videoCaseStudy-whyus-sideBg.svg?h=62c6128e826a086fda559a8d9db4e5b1";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-whyus-sideBg.svg
// module id = 1481
// module chunks = 12 15